import { Button, styled } from '@mui/material';

export const StyledButton = styled(Button)({
  fontWeight: 600,
  borderRadius: '1.6875rem',
  backgroundImage: 'linear-gradient(to bottom right, #ff9e54, #ff6e00)',
  fontSize: '1rem',
  padding: '.3125rem 2rem',
  ':disabled': {
    color: 'white',
    opacity: 0.5,
  },
  '&:hover': {
    backgroundImage: 'linear-gradient(to bottom right, #ff9e54, #ff6e00)',
    color: '#fff',
  },
});
